module.exports = __webpack_public_path__ + "img/bg2.ea707259.png";